import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { Grid, FormControlLabel, TextField, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import { Autocomplete } from '@material-ui/lab'
import 'date-fns'

import {
    Button,
    LoonsSnackbar,
    MainContainer,
    LoonsCard,
    CardTitle,
    SubTitle,
} from '../../components/LoonsLabComponents'
import { organizations, user_roles } from '../../../appconst'
// import IssueServices from '../../services'
import UserServices from '../../services/UserServices'
import OrganizationServices from 'app/services/OrganizationServices'
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'

const styleSheet = (theme) => ({})

class RegisterUser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            hasOrg: false,
            requireFeild:true,
            requireFeildError:'This field is required',
            formData: {
                firstName: null,
                lastName: null,
                designation: null,
                role: null,
                telephone: null,
                organization: null,
                email: null,
                password: null,
                verifyPassword: null,
            },
            organizationsList : [],
            activeStep: 1,
            isUpdate: false,
            catId: null,
            isLoaded: false,
            alert: false,
            message: '',
            severity: 'success',
            loading: false,
            files: { fileList: [] },
            filterData: {
                limit: 10,
                page: 0,
            },
            totalItems: 0,
            totalPages: 0,
            tableDataLoaded: false,

            confirmdialog:false,
        }
    }

    getOrganizations = async () => {
        let filterData = {
            status: 3
        }
        let res = await OrganizationServices.getAllOrganizations(filterData)

        console.log('rrrrrrrrrrrrrrrrrrrrrrr',res)
        if(res.data?.data){
            this.setState({organizationsList : res.data?.data})
        }
    }

    createNewUser = async (formData) => {
        let res = await UserServices.createNewUser(formData)
        console.log('res', res)
        if (res.status === 201) {
            
            this.setState({
                alert: true,
                message:
                    'Your request submitted. We will sent a email once your account ready!',
                severity: 'success',
            })
            this.handleRedirect()
        } else {
            this.setState({
                alert: true,
                message: 'Employee assign was unsuccessful!',
                severity: 'error',
            })
        }
    }

    handleRedirect = () => {
        setTimeout(() => {
            this.props.history.push('/session/signin')
            console.log('timeout')
        }, 2000);
    }

    isBelong = (event) => {
        this.setState({ isUpdate: !this.state.isUpdate })
    }

    handleDataSubmit = async () => {
        var formData = new FormData()
        // let files = []
        // this.state.files.fileList.forEach((element) => {
        //     form_data.append(`file`, element.file)
        // })

        formData.append(`firstName`, this.state.formData.firstName)
        formData.append(`lastName`, this.state.formData.lastName)
        formData.append(`designation`, this.state.formData.designation)
        formData.append(`role`, this.state.formData.role)
        formData.append(`telephone`, this.state.formData.telephone)
        if (!this.state.hasOrg){
            formData.append(`organizationId`, this.state.formData.organization)
        }
        formData.append(`email`, this.state.formData.email)
        formData.append(`password`, this.state.formData.password)
        formData.append(`verifyPassword`, this.state.formData.verifyPassword)

        this.createNewUser(formData)
        
        console.log("USER DATA",this.state.formData)
        console.log(this.state.requireFeild)
    }

    checkOrgAvailabiity = (e) => {
        if(e.target.checked){
            this.setState({requireFeild:false,hasOrg:true,requireFeildError:'',})
        }else {
            this.setState({requireFeild:true,hasOrg:false, requireFeildError:'This field is required'})
        }
        console.log(e.target.checked,this.state.requireFeild)
    }

    

    componentDidMount() {
        ValidatorForm.addValidationRule('isPasswordMatch',(value)=>{
            if(value !== this.state.formData.password){
                return false
            }
            return true;
        })
        this.getOrganizations()
    }

    componentWillUnmount(){
        ValidatorForm.removeValidationRule('isPasswordMatch')
    }

    async setPage(page) {
        let filterData = this.state.filterData
        filterData.page = page
        this.setState(
            {
                filterData,
            },
            () => {
                this.fetchDataSet()
            }
        )
    }

    onInputChange = (event) => {}

    render() {
        let { theme } = this.props
        const { classes } = this.props

        return (
            <Fragment>
                <MainContainer>
                    <LoonsCard>
                        <CardTitle title="New user registration" />

                        <ValidatorForm
                            className=""
                            onSubmit={() => this.handleDataSubmit()}
                            onError={() => null}
                        >
                            {/* Main Grid */}
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                className="mt-3"
                            >
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Grid container spacing={2}>
                                        {/* heading */}

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                        >
                                            <Grid container spacing={2}>
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="First Name"
                                                        required
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter first name"
                                                        name="firstName"
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .firstName
                                                        }
                                                        disabled={false}
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    firstName:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^[A-Za-z]{3,40}$',
                                                        ]}
                                                        errorMessages={[
                                                            'First Name is required',
                                                            'Insufficient characters (Input more than 3 letters & less than 40 letters)/ Invalid Name',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Last Name"
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter last name"
                                                        name="lastName"
                                                        disabled={false}
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .lastName
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    lastName:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^[A-Za-z]{3,80}$',
                                                        ]}
                                                        errorMessages={[
                                                            'Last Name is required',
                                                            'Insufficient characters (Input more than 3 letters & less than 80 letters)/ Invalid Name',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Designation"
                                                        // required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter your organization designation"
                                                        name="designation"
                                                        disabled={
                                                            this.state.hasOrg
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .designation
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this.state.formData,
                                                                    designation:e.target.value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            // 'required',
                                                            'matchRegexp:^[A-Za-z ]{1,160}$',
                                                        ]}
                                                        errorMessages={[
                                                            // 'This field is required',
                                                            'Designation is invalid',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Required Role"
                                                        required={true}
                                                    />

                                                    <Autocomplete
                                                        className="w-full"
                                                        options={user_roles}
                                                        disabled={false}
                                                        name="role"
                                                        getOptionLabel={(
                                                            option
                                                        ) => option.label}
                                                        renderInput={(
                                                            params
                                                        ) => (
                                                            <TextValidator
                                                                {...params}
                                                                // className=" w-full"
                                                                placeholder="Select the required access type to the portal"
                                                                value={
                                                                    this.state
                                                                        .formData
                                                                        .role
                                                                }
                                                                disabled={false}
                                                                InputLabelProps={{
                                                                    shrink: false,
                                                                }}
                                                                type="text"
                                                                variant="outlined"
                                                                size="small"
                                                                validators={[
                                                                    'required',
                                                                ]}
                                                                errorMessages={[
                                                                    'Role is required',
                                                                ]}
                                                            />
                                                        )}
                                                        onChange={(e, newValue) => {
                                                            if(newValue !== null){
                                                                this.setState({
                                                                    formData: {
                                                                        ...this.state.formData,
                                                                        role: newValue.value
                                                                    },
                                                                })
                                                            }
                                                        }}
                                                        onInputChange={(e, newValue) => {
                                                            if(newValue !== null){
                                                                this.setState({
                                                                    formData: {
                                                                        ...this.state.formData,
                                                                        role: newValue.value
                                                                    },
                                                                })
                                                            }
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Telephone"
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter mobile/phone number with country code.(Ex: +94756837567)"
                                                        name="telephone"
                                                        disabled={false}
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .telephone
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    telephone:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^[+]{1}[0-9]{11,15}$',
                                                        ]}
                                                        errorMessages={[
                                                            'Telephone Number is required',
                                                            'Enter valid telephone number with country code',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className="w-full"
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <FormControlLabel
                                                        value={this.state.formData.hasOrg}
                                                        control={
                                                            <Checkbox
                                                            color="primary"
                                                            // checked={this.state.hasOrg}
                                                                value={this.state.formData.hasOrg}
                                                                onChange={
                                                                    this.checkOrgAvailabiity
                                                                }
                                                                name="hasOrg"
                                                            />
                                                        }
                                                        color="primary"
                                                        label="Select this checkbox if you don't belong to any organization"
                                                        labelPlacement="right"
                                                    />
                                                </Grid>
                                            </Grid>
        {/* // ?oraganization details */}
                                            <Divider />

                                            <Grid
                                                container
                                                spacing={2}
                                                className="pt-2"
                                            >
                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Organization"
                                                        required={true}
                                                    />

                                                        <Autocomplete
                                                            className="w-full"
                                                            options={this.state.organizationsList}
                                                            disabled={
                                                                this.state.hasOrg
                                                            }
                                                            value={this.state.organizationsList.find(
                                                                (item) => item.id == this.state.formData?.organizationId
                                                            )}
                                                            name="organization"
                                                            getOptionLabel={(option) => option.organizationName ? option.organizationName : ''}
                                                            renderInput={(params) => (
                                                                <TextValidator
                                                                    {...params}
                                                                    // className=" w-full"
                                                                    placeholder="Select your organization"
                                                                    value={
                                                                        this.state.formData.organization
                                                                    }
                                                                    disabled={
                                                                        this.state.hasOrg
                                                                    }
                                                                    InputLabelProps={{
                                                                        shrink: false,
                                                                    }}
                                                                    type="text"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    validators={
                                                                        this.state.requireFeild ? ['required'] : null
                                                                    }
                                                                    errorMessages={
                                                                        this.state.requireFeild ? ['Organization is required !'] : null 
                                                                    }
                                                                />
                                                            )}
                                                            onChange={(e,newValue) => {
                                                                if(newValue != null){
                                                                    this.setState({
                                                                        formData: {
                                                                            ...this.state.formData,
                                                                            organization: newValue.id
                                                                        },
                                                                    })
                                                                }
                                                            }}
                                                        />
                                                </Grid>

                                                <Grid
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                    className="w-full flex"
                                                >
                                                    <Grid className="mt-5 pt-2">
                                                        Can't find your
                                                        organization?
                                                        <Link to="/organization/create">
                                                            <Button
                                                                className="ml-2 bg-primary rounded"
                                                                progress={false}
                                                                // type="button"
                                                                startIcon="add"
                                                                // disabled={
                                                                    // this.state.hasOrg
                                                                // }
                                                                // color="default"
                                                                onClick={()=>console.log(this.state.requireFeild)}
                                                            >
                                                                    <span className="capitalize">
                                                                        Add New
                                                                    </span>
                                                            </Button>
                                                        </Link>
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Email"
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter your email"
                                                        name="email"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .email
                                                        }
                                                        type="text"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    email: e
                                                                        .target
                                                                        .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'isEmail',
                                                        ]}
                                                        errorMessages={[
                                                            'An Email Address is required',
                                                            'email is not valid',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    {/* blank */}
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Password"
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Enter your password"
                                                        name="password"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .password
                                                        }
                                                        type="password"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    password:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'matchRegexp:^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&*?!]).{8,255}$',
                                                        ]}
                                                        errorMessages={[
                                                            'Password is required',
                                                            'Password must include at least one uppercase letter, one lowercase letter, one number, one special character(@#$%&*?!), and be at least 8 characters long.',
                                                        ]}
                                                    />
                                                </Grid>

                                                <Grid
                                                    className=" w-full"
                                                    item
                                                    lg={6}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <SubTitle
                                                        title="Verify password"
                                                        required={true}
                                                    />

                                                    <TextValidator
                                                        className=" w-full"
                                                        placeholder="Verify your password"
                                                        name="repeatPassword"
                                                        disabled={
                                                            this.state.isUpdate
                                                        }
                                                        InputLabelProps={{
                                                            shrink: false,
                                                        }}
                                                        value={
                                                            this.state.formData
                                                                .verifyPassword
                                                        }
                                                        type="password"
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                formData: {
                                                                    ...this
                                                                        .state
                                                                        .formData,
                                                                    verifyPassword:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        }}
                                                        validators={[
                                                            'required',
                                                            'isPasswordMatch',
                                                        ]}
                                                        errorMessages={[
                                                            'Verify Password is required',
                                                            'Password Mismatch!',
                                                        ]}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={2}
                                                className="pt-4 my-5"
                                            >
                                                <Grid
                                                    item
                                                    className=""
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <Button
                                                        className="mt-2 mr-2"
                                                        progress={false}
                                                        type="submit"
                                                        startIcon="save"
                                                        color="primary"
                                                        // onClick={this.handleDataSubmit}
                                                    >
                                                        <span className="capitalize">
                                                            Submit
                                                        </span>
                                                    </Button>
                                                    {/* <Link to="/"> */}
                                                        <Button
                                                            className="mt-2 mr-2"
                                                            progress={false}
                                                            type="button"
                                                            startIcon="close"
                                                            color="secondary"
                                                            onClick={()=>{
                                                                this.setState({confirmdialog:true})
                                                            }}
                                                        >
                                                            <span className="capitalize">
                                                                Cancel
                                                            </span>
                                                        </Button>
                                                    {/* </Link> */}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </LoonsCard>
                </MainContainer>

                <Dialog
                    open={this.state.confirmdialog}
                    onClose={()=>{
                        this.setState({confirmdialog:false})
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>Confirm Cancellation</DialogTitle>
                    <DialogContent>
                        Are you sure that you want to cancel?
                    </DialogContent>
                    <DialogActions>
                        <Link to= "/users">
                            <Button 
                                className='bg-primary'
                                variant="contained"
                                // startIcon={<CloseIcon/>}
                            >
                                Yes
                            </Button>
                        </Link>
                        <Button 
                            onClick={()=>{
                                this.setState({confirmdialog:false})
                            }}
                            className='bg-error'
                            variant="contained"
                            // startIcon={<CloseIcon/>}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <LoonsSnackbar
                    open={this.state.alert}
                    onClose={() => {
                        this.setState({ alert: false })
                    }}
                    message={this.state.message}
                    autoHideDuration={3000}
                    severity={this.state.severity}
                    elevation={2}
                    variant="filled"
                ></LoonsSnackbar>
            </Fragment>
        )
    }
}

export default withStyles(styleSheet)(RegisterUser)
